export default __webpack_public_path__ + "static/media/imgLoja03.7aafb3b1.png";